import axios from 'axios';
import applyCaseMiddleware from 'axios-case-converter';

import { ApiResponse } from 'types';
import API_END_POINT from 'constants/apiEndPoints';

interface CreateAccessTokenParams {
  refreshToken: string;
}

interface CreateAccessTokenResponse extends ApiResponse {
  accessToken: string;
  refreshToken: string;
}

type CreateAccessToken = (params: CreateAccessTokenParams) => Promise<CreateAccessTokenResponse>;

const createAccessToken: CreateAccessToken = async ({ refreshToken }) => {
  const apiClient = applyCaseMiddleware(
    axios.create({
      baseURL: process.env.REACT_APP_API_URL,
    })
  );
  const { data } = await apiClient.post(API_END_POINT.USER.CREATE_ACCESS_TOKEN, undefined, {
    headers: {
      Authorization: `Bearer ${refreshToken}`,
    },
  });

  return data;
};

export default createAccessToken;
